<template>
  <v-app>
    <v-container class="hidden-md-and-down">
      <v-card
        width="96%"
        style="margin:auto;border-radius:12px"
        elevation="12"
        class="createAccount white--text text-center pa-12"
      >
        <h2 style="font-size:49x">Built for African Creators, Authors, Journalists, Writers and Organizations</h2>
      </v-card>

      <v-row>
        <v-col>
          <v-card
            width="82%"
            height="300px"
            color="#f9f9f9"
            class="pa-8 text-center mt-12 animate__animated animate__fadeInUp"
            style="margin:auto;border-radius:19px"
          >
            <v-btn fab depressed color="red" class="white--text mb-4"
              ><v-icon>mdi-palette</v-icon></v-btn
            >
            <h2 style="font-size:20px" class="mb-3">
              Showcase your creativity
            </h2>
            <p>
              Build a one-page site in less than a minute to showcase works
              created by you.
            </p>
          </v-card>
        </v-col>
        <v-col>
          <v-card
            width="82%"
            color="#f9f9f9"
            height="300px"
            class="pa-8 text-center mt-12 animate__animated animate__fadeInDown"
            style="margin:auto;border-radius:19px"
          >
            <v-btn fab depressed color="red" class="white--text mb-4"
              ><v-icon>mdi-cash-multiple</v-icon></v-btn
            >
            <h2 style="font-size:20px" class="mb-3">
              Get the support you deserve
            </h2>
            <p>
              Earn monetary support from your fans, wellwishers and supporters.
              Withdraw at any time.
            </p>
          </v-card>
        </v-col>
        <v-col>
          <v-card
            width="82%"
            color="#f9f9f9"
            height="300px"
            class="pa-8 text-center mt-12 animate__animated animate__fadeInUp"
            style="margin:auto;border-radius:19px"
          >
            <v-btn fab depressed color="red" class="white--text mb-4"
              ><v-icon>mdi-email-newsletter</v-icon></v-btn
            >
            <h2 style="font-size:20px" class="mb-3">
              Build Lasting Relationships
            </h2>
            <p>
              Grow your email list and send out emails for free to people who
              value your content.
            </p>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <v-container class="hidden-lg-and-up">
      <v-card
        width="82%"
        style="margin:auto;border-radius:12px"
        elevation="12"
        class="createAccount white--text text-center pa-12"
      >
        <h2 style="font-size:49x">Built for African Creators, Authors, Journalists, Writers and Organizations</h2>
      </v-card>

      <v-card
        width="82%"
        color="#f9f9f9"
        class="pa-6 text-center mt-12"
        style="margin:auto;border-radius:19px"
      >
        <v-btn fab depressed color="red" class="white--text mb-4"
          ><v-icon>mdi-palette</v-icon></v-btn
        >
        <h2 style="font-size:20px" class="mb-3">Showcase your creativity</h2>
        <p>
          Build a one-page site in less than a minute to showcase works created
          by you.
        </p>
      </v-card>

      <v-card
        width="82%"
        color="#f9f9f9"
        class="pa-6 text-center mt-12"
        style="margin:auto;border-radius:19px"
      >
        <v-btn fab depressed color="red" class="white--text mb-4"
          ><v-icon>mdi-cash-multiple</v-icon></v-btn
        >
        <h2 style="font-size:20px" class="mb-3">Get the support you deserve</h2>
        <p>
          Earn monetary support from your fans, wellwishers and supporters.
          Withdraw at any time.
        </p>
      </v-card>

      <v-card
        width="82%"
        color="#f9f9f9"
        class="pa-6 text-center mt-12"
        style="margin:auto;border-radius:19px"
      >
        <v-btn fab depressed color="red" class="white--text mb-4"
          ><v-icon>mdi-email-newsletter</v-icon></v-btn
        >
        <h2 style="font-size:20px" class="mb-3">Build Lasting Relationships</h2>
        <p>
          Grow your email list and send out emails for free to people who value
          your content.
        </p>
      </v-card>
    </v-container>
  </v-app>
</template>

<script>
export default {
  data() {
    return {
      creatorType: "Content Creators"
    };
  },
  created() {
    if (this.creatorType == "Content Creators") {
      setTimeout(() => {
        this.creatorType = "Journalists";
      }, 1000);
    }
    if (this.creatorType == "Journalists") {
      setTimeout(() => {
        this.creatorType = "Content Creator";
      }, 1000);
    }
  }
};
</script>
